import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

interface OrgOnboardingBannerProps {
  onStart: () => void;
}

// Org-side mirror of AgentOnboardingBanner — persistent nudge for admins who
// skip the org onboarding wizard. Bottom-fixed and intentionally NOT
// session-dismissible: it stays until the admin completes their profile setup.
// Mounted by OrgOnboardingGate, which owns the visibility logic (settled +
// admin + admin context + not completed + wizard closed + on /admin/feed).
const OrgOnboardingBanner = ({ onStart }: OrgOnboardingBannerProps) => {
  return (
    <div
      role="region"
      aria-label="Complete your organization's story"
      className="fixed bottom-0 left-0 right-0 md:left-64 z-[55] bg-ink-900 text-white border-t border-white/10"
    >
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 px-4 py-3 text-center text-[13px] sm:text-sm leading-snug">
        <span className="inline-flex items-center gap-2 text-white/90">
          <Sparkles className="h-4 w-4 text-white/70 flex-shrink-0" />
          Attract the right agents — finish your organization's story (2–3 min)
        </span>
        <Button
          size="sm"
          onClick={onStart}
          className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold"
        >
          Start
        </Button>
      </div>
    </div>
  );
};

export default OrgOnboardingBanner;
